import React from 'react'
import { ColumnMapping, SpreadsheetMapping } from 'api'
import { TradingRelationshipSpreadsheetParseResult } from './parseTradingRelationshipSpreadsheet'
import { Locale, Translation } from 'locale'
import { ColumnMappingStringPanel, ColumnsContainer, ColumnsHeader, ColumnsHeaderPanel } from '../upload/mappingDialog'

export interface TradingRelationshipMappingDialogColumnsProps {
  mapping: SpreadsheetMapping
  parseResult: TradingRelationshipSpreadsheetParseResult
  onUpdate: (mapping: SpreadsheetMapping) => unknown
}

export const TradingRelationshipMappingDialogColumns: React.FC<TradingRelationshipMappingDialogColumnsProps> = props => {
  const { mapping, parseResult, onUpdate } = props

  const handleColumnUpdate = (columnMapping: ColumnMapping, fieldName: keyof SpreadsheetMapping) =>
    onUpdate({ ...mapping, [fieldName]: columnMapping })

  return (
    <ColumnsContainer>
      <ColumnsHeaderPanel>
        <ColumnsHeader>{Locale.translate(Translation.TC_TRADING_RELATIONSHIP_FIELD)}</ColumnsHeader>
        <ColumnsHeader>{Locale.translate(Translation.TC_SPREADSHEET_COLUMN)}</ColumnsHeader>
      </ColumnsHeaderPanel>

      <ColumnMappingStringPanel
        fieldTitle={Locale.translate(Translation.TC_RELATIONSHIP_ACTION)}
        fieldName="relationshipAction"
        columnMapping={mapping.relationshipAction}
        parseResult={parseResult}
        onUpdate={handleColumnUpdate}
      />

      <ColumnMappingStringPanel
        fieldTitle={Locale.translate(Translation.TC_BUY_ORGANISATION)}
        fieldName="buyOrganisation"
        columnMapping={mapping.buyOrganisation}
        parseResult={parseResult}
        onUpdate={handleColumnUpdate}
      />
      <ColumnMappingStringPanel
        fieldTitle={Locale.translate(Translation.TC_BUY_TRADING_ENTITY)}
        fieldName="buyTradingEntity"
        columnMapping={mapping.buyTradingEntity}
        parseResult={parseResult}
        onUpdate={handleColumnUpdate}
      />
      <ColumnMappingStringPanel
        fieldTitle={Locale.translate(Translation.TC_SELL_ORGANISATION)}
        fieldName="sellOrganisation"
        columnMapping={mapping.sellOrganisation}
        parseResult={parseResult}
        onUpdate={handleColumnUpdate}
      />
      <ColumnMappingStringPanel
        fieldTitle={Locale.translate(Translation.TC_SELL_TRADING_ENTITY)}
        fieldName="sellTradingEntity"
        columnMapping={mapping.sellTradingEntity}
        parseResult={parseResult}
        onUpdate={handleColumnUpdate}
      />
      <ColumnMappingStringPanel
        fieldTitle={Locale.translate(Translation.TC_US_SC_ENABLED)}
        fieldName="usSponsoredClearing"
        columnMapping={mapping.usSponsoredClearing}
        parseResult={parseResult}
        onUpdate={handleColumnUpdate}
      />
      <ColumnMappingStringPanel
        fieldTitle={Locale.translate(Translation.TC_US_SC_DEFAULT)}
        fieldName="usSponsoredClearingDefault"
        columnMapping={mapping.usSponsoredClearingDefault}
        parseResult={parseResult}
        onUpdate={handleColumnUpdate}
      />
      <ColumnMappingStringPanel
        fieldTitle={Locale.translate(Translation.TC_MASTER_LEGAL_AGREEMENTS)}
        fieldName="masterLegalAgreements"
        columnMapping={mapping.masterLegalAgreements}
        parseResult={parseResult}
        onUpdate={handleColumnUpdate}
      />
      <ColumnMappingStringPanel
        fieldTitle={Locale.translate(Translation.TC_DEFAULT_AGREEMENT)}
        fieldName="defaultAgreement"
        columnMapping={mapping.defaultAgreement}
        parseResult={parseResult}
        onUpdate={handleColumnUpdate}
      />
    </ColumnsContainer>
  )
}
